import { render, staticRenderFns } from "./CapacityUpdateDialog.vue?vue&type=template&id=0fb0cdec"
import script from "./CapacityUpdateDialog.vue?vue&type=script&lang=js"
export * from "./CapacityUpdateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports